import { Component, OnInit } from '@angular/core';
import { SifarnikProcesiService } from './sifarnik-procesi.service';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { moduli } from '../../config';


@Component({
  selector: 'app-sifarnik-procesi',
  templateUrl: './sifarnik-procesi.component.html',
  styleUrls: ['./sifarnik-procesi.component.scss'],
  providers: [SifarnikProcesiService],
})
export class SifarnikProcesiComponent implements OnInit {
  procesi = [];
  noDataMessage = 'Učitavanje...';

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: SifarnikProcesiService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().sifarnikProcesi;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiProcese();
  }

  onAddProcess(data) {
    //console.log(data);
    let onAddProcessObject = {
      procesnaziv: data.data.naziv,
      aktivan: data.data.aktivan === 'Aktivan' ? 1 : 0
    };
    //console.log(onAddProcessObject);
    this.service.addProcess(onAddProcessObject).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiProcese();
        notify("Proces je uspješno dodan!", "success", 3000);
      } else {
        this.dohvatiProcese();
        notify("Došlo je do pogreške, pokušajte ponovno!", "warning", 3000);
      }
    });
  }

  onProcessUpdate(data) {
    //console.log(data);
    let onEditObject = {
      idproces: data.data.id,
      procesnaziv: data.data.naziv,
      aktivan: data.data.aktivan === 'Aktivan' ? 1 : 0
    };
    //console.log(onEditObject);
    this.service.editProcess(onEditObject).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiProcese();
        notify("Proces je uspješno uređen!", "success", 3000);
      } else {
        this.dohvatiProcese();
        notify("Došlo je do pogreške, pokušajte ponovno!", "warning", 3000);
      }
    });
  }

  onProcessRemove(data: any): void {
    //console.log(data);
    const id = data.data.id;
    this.service.deleteProces({idproces: id}).subscribe((res) => {
      //console.log(res);
      if (res.data[0][0].rezultat === 1) {
        this.dohvatiProcese();
        notify("Uspješno brisanje procesa.", "success", 3000);
      } else if (res.data[0][0].rezultat === 0) {
        this.dohvatiProcese();
        notify("Odabrani proces nije moguće obrisati!", "warning", 3000);
      } else {
        this.dohvatiProcese();
        notify("Došlo je do pogreške, pokušajte ponovno!", "error", 3000);
      }
    });
  }

  dohvatiProcese() {
    this.service.dohvatiSveProcese({}).subscribe((res) => {
      //console.log(res);
      this.procesi = [];
      if (res.success === true) {
        for (let proces of res.data) {
          this.procesi.push({
            id: proces.idproces,
            aktivan: proces.ps_aktivanproces ? 'Aktivan' : 'Neaktivan',
            naziv: proces.ps_naziv,
          });
        }
        //console.log(this.procesi);
      }
    });
  }
}
